import { ProductType } from '@ads/front-core/api'
import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import {
  CampaignTypeItem,
  ProductConfigItem,
  Product,
  AllProductTypes,
  WizardSubCategoryEnum,
} from '@ads/front-core/interfaces'
import { lng } from '@ads/front-core/locales'
import { DEFINITIONS } from './definitions'

export const getProductDefinition = (
  productTypeId: ProductType,
): IProductDefinition => DEFINITIONS[productTypeId]

export const getProductDefinitionBySlug = (
  slug: string,
): IProductDefinition => {
  const product = Object.values(DEFINITIONS).find(definition => {
    if (!definition) {
      return false
    }
    return definition.createUrl.includes(slug)
  })

  return product
}

const getWizardProductFromDefinition = (
  definition: IProductDefinition,
): Product => {
  return {
    id: definition.productTypeId,
    budgetModel: [definition.budget.model],
    productDescription: definition.wizard.productDescription,
    parameters: definition.wizard.parameters,
    url: definition.createUrl,
  }
}

export const getWizardProducts = (): Record<AllProductTypes, Product> => {
  return Object.values(DEFINITIONS).reduce((acc, item) => {
    if (!item) {
      return acc
    }
    acc[item.productTypeId] = getWizardProductFromDefinition(item)
    return acc
  }, {} as Record<AllProductTypes, Product>)
}

export const getWizardProductsForSubcategory = (
  subCategory: WizardSubCategoryEnum,
  fallbackProducts?: Product[],
): Product[] => {
  return Object.values(DEFINITIONS).reduce((acc, item) => {
    if (!item || item.wizard.subCategory !== subCategory) {
      return acc
    }
    acc.push(getWizardProductFromDefinition(item))
    return acc
  }, fallbackProducts || [])
}

export const getProductsForCampaignTypeList = (): CampaignTypeItem[] => {
  return Object.values(DEFINITIONS).reduce((acc, item) => {
    if (!item) {
      return acc
    }
    if (!item.productTypeId.match(/UNIVERSAL_/)) {
      acc.push({
        id: item.productTypeId,
        type: item.budget.model,
        label: lng(item.title),
        techLabel: item.titleForAdmin,
        filters: {
          types: [item.productTypeId],
        },
        availableFor: item.productAvailableFor,
      })
    }
    return acc
  }, [] as CampaignTypeItem[])
}

export const getMinimumRatesProducts = (): Record<
  ProductType,
  ProductConfigItem
> => {
  return Object.values(DEFINITIONS).reduce((acc, item) => {
    if (!item) {
      return acc
    }
    const minimumRateProduct: ProductConfigItem = {
      type: item.campaignMinimumRates.inputType,
      withDevices: item.budget.variant !== 'ANY',
      rateKeys: item.campaignMinimumRates.fields,
    }
    acc[item.productTypeId] = minimumRateProduct
    return acc
  }, {} as Record<ProductType, ProductConfigItem>)
}
